




































































































































































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { mapState } from "vuex";
import Context from "@/mixins/context";
// Mixins
import RequestPromises from "@/mixins/requestPromises";

// Enums
import { DataModules } from "@/store/modules/data";
import { AdminRoutes } from "@/data/enums/router";

// Types
import { IEmail, ISentEmail } from "@/models/emails";
import { IState } from "@/store";
import { SentEmailStatus } from "@/data/enums/emails";
import { ITemplate } from "@/models/templates";
import { IHookLog } from "@/models/hooks";

@Component({
  computed: {
    ...mapState({
      getDataScope(state: IState, getters) {
        return getters[`data/${this.dataModule}/scope`](this.emailId);
      },
      email(state: IState, getters) {
        return getters[`data/single`]({
          storeModule: this.dataModule,
          scope: this.dataScope
        });
      },
      template(state: IState, getters) {
        return getters[`data/single`]({
          storeModule: DataModules.TEMPLATES,
          scope: this.dataScope
        });
      },
      log(state: IState, getters) {
        return getters[`data/single`]({
          storeModule: DataModules.HOOKS_LOGS,
          scope: this.dataScope
        });
      }
    })
  }
})
export default class ViewEmailModal extends Mixins(RequestPromises, Context) {
  // Getters
  public readonly email!: ISentEmail;
  public readonly getDataScope!: string;
  public readonly log!: IHookLog;
  public readonly template!: ITemplate;

  @Prop({ required: true })
  public emailId!: IEmail["id"];

  @Prop({
    default: () => params => ({
      name: "adminEmailLog",
      params
    })
  })
  public viewRoute!: (params) => { [key: string]: string };

  public loading = true;
  public reloading = false;
  public isProcessing = false;
  public isSendProcessing = false;
  public requestError = false;

  public dataModule: string = DataModules.EMAILS;
  public dataScope = "";
  public routeName = AdminRoutes.EMAIL_TEMPLATE_EDIT;

  // Lifecycle methods
  public async created() {
    this.dataScope = this.getDataScope;
    await this.loadData();
    if (this.isAdmin) {
      await Promise.all([this.getTemplate(), this.getLog()]);
    }
  }

  public beforeDestroy() {
    // Bin template
    this.$store.dispatch("data/bin", {
      storeModule: DataModules.TEMPLATES,
      scope: this.dataScope,
      vm: this
    });
    // Bin log
    this.$store.dispatch("data/bin", {
      storeModule: DataModules.HOOKS_LOGS,
      scope: this.dataScope,
      vm: this
    });
    // Bin email
    this.$store.dispatch("data/bin", {
      storeModule: this.dataModule,
      scope: this.dataScope,
      vm: this
    });
    this.clearRoute(this.emailId);
  }

  //Computed

  public get isError() {
    return (
      this.$store.getters[`data/${DataModules.EMAILS}/status`](
        this.email || {}
      ) === SentEmailStatus.ERROR
    );
  }

  public get isSent() {
    return (
      this.$store.getters[`data/${DataModules.EMAILS}/status`](
        this.email || {}
      ) === SentEmailStatus.SENT
    );
  }

  public get isBounced() {
    return (
      this.$store.getters[`data/${DataModules.EMAILS}/status`](
        this.email || {}
      ) === SentEmailStatus.BOUNCED
    );
  }

  public get isSending() {
    return (
      this.$store.getters[`data/${DataModules.EMAILS}/status`](
        this.email || {}
      ) === SentEmailStatus.SENDING
    );
  }

  public get canResend() {
    return this.isAdmin && this.$userCan("resend_email_message");
  }

  public get bouncedAfter() {
    const bounced = this.$_.get(this.email, "bounced");
    const bouncedAt = this.$_.get(this.email, "bounced_at");
    const createdAt = this.$_.get(this.email, "created_at");
    if (!bounced) return "";
    return this.$moment(createdAt).from(this.$moment(bouncedAt), true);
  }

  // Methods

  public clearRoute(emailId) {
    if (
      [this.viewRoute({ emailId }).name].includes(this.$route.name as string) &&
      this.$route.params.emailId === emailId
    ) {
      const path = this.$route.fullPath.replace(emailId, "");
      this.$router.replace(path).catch(err => err);
    }
  }

  public async loadData(ignoreStored = false) {
    try {
      await this.$store.dispatch(`data/${this.dataModule}/get`, {
        id: this.emailId,
        params: {
          with: "data"
        },
        scope: this.dataScope,
        vm: this,
        ignoreStored
      });
      this.requestError = false;
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
      this.requestError = true;
    }

    this.reloading = false;
    this.loading = false;
  }

  public reloadData() {
    this.reloading = true;
    this.loadData(true);
  }

  public getTemplate() {
    if (!this.email.template_id) return;
    return this.$store.dispatch(`data/${DataModules.TEMPLATES}/get`, {
      id: this.email.template_id,
      scope: this.dataScope,
      vm: this
    });
  }

  public getLog() {
    if (!this.email?.hook_log_id) return;
    return this.$store.dispatch(`data/${DataModules.HOOKS_LOGS}/get`, {
      id: this.email.hook_log_id,
      scope: this.dataScope,
      params: {
        with: "hook"
      },
      vm: this
    });
  }

  public viewOriginalEmail() {
    this.$emit("close");
    this.clearRoute(this.emailId);
    this.$bus.$emit("admin/emails/view", {
      emailId: this.email?.resend_email_id
    });
  }

  public async sendEmail() {
    if (this.isProcessing || this.isSendProcessing) return;
    try {
      this.isSendProcessing = true;
      await this.$store.dispatch(`data/${this.dataModule}/send`, {
        id: this.email.id
      });
      this.$buefy.toast.open({
        message: this.$t("_sentence.successfully_sent") as string
      });
      this.$emit("refresh");
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    } finally {
      await this.loadData(true);
      this.isSendProcessing = false;
    }
  }

  public async resendEmail() {
    if (!this.isProcessing && this.canResend) {
      try {
        this.isProcessing = true;
        await this.$store.dispatch(`data/${this.dataModule}/resend`, {
          id: this.email.id
        });
        this.$emit("close");
        this.$emit("refresh");
        this.$bus.$emit("admin/emails/refresh");
        this.$buefy.toast.open({
          message: this.$t("_sentence.successfully_sent") as string
        });
      } catch (error) {
        this.$store.dispatch("api/handleError", error);
      } finally {
        this.isProcessing = false;
      }
    }
  }
}
